/* eslint-disable no-underscore-dangle */
const { PDLScriptProps } = window._webpack_init_props;
delete window._webpack_init_props.PDLScriptProps;

window._PDL = { ...window._PDL, ...PDLScriptProps };
